import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { CarouselComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-carousel',
  standalone: false,
  templateUrl: './custom-carousel.component.html',
  styleUrl: './custom-carousel.component.scss'
})
export class CustomCarouselComponent extends CarouselComponent{
  ref = inject(ChangeDetectorRef);
}
